/**
 * API Configuration
 * Centralized API endpoint definitions
 *
 * Note: The useApiConfig composable is located in composables/useApiConfig.ts
 * for Nuxt auto-import support
 */

/**
 * API Endpoints
 * All backend API endpoint paths
 */
export const API_ENDPOINTS = {
  // Events
  EVENTS: '/events',
  CREATE_EVENT: '/events/create-event',
  SUGGEST_EVENT: '/events/suggest-event',
  REFRESH_EVENTS: '/events/refresh-events',
  EVENT_BY_DEPARTMENTS: '/events/event-by-departements',
  EVENTS_BY_DATE: '/events/events-by-date',
  STATS: '/app-state',
  EVENT_ADD_ADDRESS: (eventId: number) => `/events/${eventId}/add-address`,
} as const;
